var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 50,
    viewBox: "0 0 230 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1899 31.7938H15.1488V38.173H25.1899V31.7938Z",
    fill: "url(#paint0_linear_494_408)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3028 10.818C15.6547 10.8238 10.2396 13.07 6.24581 17.0638C2.25201 21.0576 0.00577021 26.4727 0 32.1208V48.6646H6.3792V32.1934C6.38305 28.2174 7.96424 24.4053 10.7757 21.5938C13.5872 18.7823 17.3994 17.2011 21.3754 17.1972H36.9383V10.818H21.3028Z",
    fill: "url(#paint1_linear_494_408)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5353 21.3022C18.6049 21.3042 15.7952 22.4691 13.7232 24.5411C11.6511 26.6132 10.4862 29.4229 10.4843 32.3532V48.6645H16.8707V32.1934C16.8727 30.9993 17.3479 29.8546 18.1922 29.0102C19.0366 28.1658 20.1813 27.6906 21.3754 27.6887H36.9383V21.3022H21.5353Z",
    fill: "url(#paint2_linear_494_408)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0519 34.6928L35.6015 34.3513L36.0592 33.9808C39.1272 31.5319 41.3561 28.1881 42.4361 24.4141C43.5161 20.64 43.3936 16.6233 42.0856 12.9221C40.7775 9.22097 38.349 6.01922 35.1374 3.76189C31.9259 1.50457 28.0908 0.303801 24.1654 0.326488H0V6.70569H24.1654C25.8381 6.66543 27.502 6.96012 29.0591 7.57242C30.6163 8.18473 32.0352 9.10227 33.2325 10.2711C34.4298 11.4399 35.3812 12.8364 36.0308 14.3783C36.6804 15.9203 37.015 17.5766 37.015 19.2498C37.015 20.923 36.6804 22.5793 36.0308 24.1212C35.3812 25.6632 34.4298 27.0596 33.2325 28.2284C32.0352 29.3972 30.6163 30.3148 29.0591 30.9271C27.502 31.5394 25.8381 31.8341 24.1654 31.7938H23.7077V38.173H26.7883C29.4206 38.1769 31.9439 39.2248 33.8045 41.0868C35.6651 42.9488 36.7112 45.4728 36.7131 48.1051V48.6646H43.0923V48.1051C43.0873 45.4675 42.4444 42.8702 41.2185 40.5347C39.9926 38.1993 38.22 36.195 36.0519 34.6928Z",
    fill: "#53EB95"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.284 7.46856V8.45669H220.656V13.5571H219.436V8.45669H217.816V7.46856H222.284Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230 7.46856V13.5571H228.779V9.59739L227.152 13.5571H226.229L224.587 9.59739V13.5571H223.367V7.46856H224.754L226.687 11.995L228.627 7.46856H230Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.364 16.042V22.1233C64.1673 22.1233 62.0605 22.9959 60.5072 24.5492C58.9539 26.1026 58.0813 28.2093 58.0813 30.4061V48.6645H51.2516V31.1544C51.2535 27.1469 52.8463 23.3041 55.68 20.4704C58.5138 17.6367 62.3566 16.0439 66.364 16.042Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8167 49.6744C76.6957 49.6744 69.4301 42.278 69.4301 32.3532C69.4301 22.3049 76.6957 15.032 86.6859 15.032C96.2329 15.032 102.743 22.3703 102.743 32.3532C102.747 33.1804 102.683 34.0065 102.554 34.8235H76.5722C77.4586 40.1928 81.3166 43.5422 86.8748 43.5422C88.6675 43.6209 90.4521 43.2586 92.0723 42.4872C93.6924 41.7158 95.0986 40.5587 96.1675 39.1175L100.149 43.2298C96.9304 47.5238 92.3749 49.6744 86.8167 49.6744ZM76.5722 29.8902H95.9786C95.4773 24.7025 91.8082 21.0407 86.5333 21.0407C81.1568 21.0407 77.4295 24.5136 76.5431 29.8902",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.923 48.6646L104.603 16.0493H111.934L120.347 42.6632H120.595L129.008 16.0493H136.274L125.019 48.6646H115.923Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.938 16.042H142.108V48.6645H148.938V16.042Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.077 48.6646L154.765 16.0493H162.096L170.509 42.6632H170.756L179.163 16.0493H186.435L175.181 48.6646H166.077Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M205.29 49.6744C195.176 49.6744 187.903 42.278 187.903 32.3532C187.903 22.3049 195.169 15.032 205.159 15.032C214.706 15.032 221.216 22.3703 221.216 32.3532C221.223 33.1805 221.16 34.0069 221.027 34.8235H195.045C195.932 40.1928 199.79 43.5422 205.348 43.5422C207.141 43.6215 208.925 43.2596 210.546 42.4881C212.166 41.7166 213.572 40.5592 214.641 39.1175L218.629 43.2298C215.403 47.5238 210.848 49.6744 205.29 49.6744ZM195.045 29.8902H214.459C213.95 24.7025 210.281 21.0407 205.014 21.0407C199.637 21.0407 195.91 24.5136 195.023 29.8902",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_494_408",
    x1: 0,
    y1: 25.0003,
    x2: 230.166,
    y2: 25.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53EB95",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#53EB95",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#53EB95",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#53EB95",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#53EB95",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#53EB95",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#53EB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54EC96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_494_408",
    x1: 0,
    y1: 25.005,
    x2: 230,
    y2: 25.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBB03B",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FBB03B",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FBB03B",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FBB03B",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FBB03B",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FBB03B",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBB03B",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FBB03B",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB03B",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_494_408",
    x1: 0,
    y1: 25.0003,
    x2: 230,
    y2: 25.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FF7755",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FF7755",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF7755",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF7755",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FF7755",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FF7755",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FF7755",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FF7755",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7755",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviveLogo);
export default __webpack_public_path__ + "static/media/Revive-logo.d96d1565520d0e8dc11c704a7365f3fc.svg";
export { ForwardRef as ReactComponent };